// API 与应用配置

// 应用标题（侧栏等显示，来自 .env 的 VITE_APP_TITLE）
export const APP_TITLE = import.meta.env.VITE_APP_TITLE || 'holodao 产品中心';

// Odoo API 代理地址（根据实际部署调整）
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8069';

import type { Supplier } from '../types/supplier';
import { getSupplierPrefix } from '../types/supplier';

// 默认 API 路径前缀（GIGA）
export const API_PREFIX = '/api/giga';

export function getApiPrefix(supplier: Supplier = 'giga'): string {
  return getSupplierPrefix(supplier);
}

// 请求超时时间（毫秒）
export const REQUEST_TIMEOUT = 30000;

// 获取完整的 API URL
export function getApiUrl(path: string): string {
  return `${API_BASE_URL}${API_PREFIX}${path}`;
}
